import QRCodeStyling, { Options } from "qr-code-styling";

export const generateAndDownloadQr = (
  url: string,
  logoUrl: string,
  filename = "qrcode.png"
) => {
  const qrCode = new QRCodeStyling({
    width: 300,
    height: 300,
    type: "png", // bisa svg/png/jpeg
    data: url,
    image: logoUrl,
    dotsOptions: {
      color: "#000",
      type: "rounded",
    },
    backgroundOptions: {
      color: "#fff",
    },
    imageOptions: {
      crossOrigin: "anonymous",
      margin: 5,
    },
  } as unknown as Options);

  // langsung trigger download
  qrCode.download({ name: filename, extension: "png" });
};
